module.exports = __webpack_public_path__ + "img/catalog-thumbnail.22384c7.jpg";